@if (productData && hasValidTranslations) {
<section class="section-4 mt-4 pt-4 mb-6 mb-lg-7">
    @for (overviewKeys of groupedContent['SECTION-4']; track overviewKeys;) {
    @if (overviewKeys.headingText || overviewKeys.descriptionText) {
    <div class="container text-center mb-4">
        <div class="row justify-content-center">
            <div class="col-12 col-lg-10">
                @if (overviewKeys.headingText) {
                <h2
                    [innerHTML]="overviewKeys.headingText"
                    class="text-blue-300"
                ></h2>
                } @if (overviewKeys.descriptionText) {
                <div [innerHTML]="overviewKeys.descriptionText"></div>
                }
            </div>
        </div>
    </div>
    } } @for (inlineBannerKeys of groupedContent['SECTION-4_INLINE-BANNER'];
    track inlineBannerKeys; let i = $index; let odd = $odd;) { @if (
    inlineBannerKeys.buttonText || inlineBannerKeys.buttonUrl ||
    inlineBannerKeys.descriptionText || inlineBannerKeys.headingText ||
    inlineBannerKeys.desktopImageUrl || inlineBannerKeys.tabletImageUrl ||
    inlineBannerKeys.mobileImageUrl || inlineBannerKeys.imageAltText ||
    inlineBannerKeys.tabletImageAltText || inlineBannerKeys.mobileImageAltText
    || inlineBannerKeys.linkText || inlineBannerKeys.linkUrl ||
    inlineBannerKeys.videoId ) {
    <div class="mb-3 mb-sm-4 mb-md-5 mb-lg-6">
        <div class="container">
            <vision2-inline-banner
                [backgroundImage]="inlineBannerKeys.desktopImageUrl"
                [backgroundImageTablet]="inlineBannerKeys.tabletImageUrl"
                [backgroundImageMobile]="inlineBannerKeys.mobileImageUrl"
                [backgroundImageAltText]="inlineBannerKeys.imageAltText"
                [backgroundImageTabletAltText]="
                    inlineBannerKeys.tabletImageAltText
                "
                [backgroundImageMobileAltText]="
                    inlineBannerKeys.mobileImageAltText
                "
                [buttonText]="inlineBannerKeys.buttonText"
                [buttonUrl]="inlineBannerKeys.buttonUrl"
                [colorClass]="'text-bg-gray-20'"
                [description]="inlineBannerKeys.descriptionText"
                [heading]="inlineBannerKeys.headingText"
                [headingValue]="2"
                [linkText]="inlineBannerKeys.linkText"
                [linkUrl]="inlineBannerKeys.linkUrl"
                [type]="odd ? 'right' : 'left'"
                [modalVideoId]="inlineBannerKeys.videoId"
            >
            </vision2-inline-banner>
        </div>
    </div>
    } }
</section>
}
